import { createContext, useContext, useEffect, useMemo } from 'react';
import useAuth from '../hooks/useAuth';
import Cookies from 'js-cookie';

const AppContext = createContext<{
  isWebView: boolean;
  token: string;
}>({
  isWebView: false,
  token: '',
});

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const { isAppReady, user, token } = useAuth();
  const searchParams = new URLSearchParams(window.location.search);
  const isWebViewParam = searchParams.get('webview') === 'true';

  useEffect(() => {
    if (isWebViewParam) {
      Cookies.set('isWebView', 'true');
    }
  }, [isWebViewParam]);

  const isWebView = useMemo(() => {
    return isWebViewParam || Cookies.get('isWebView') === 'true';
  }, [isWebViewParam]);

  const values = useMemo(
    () => ({
      isWebView,
      isAppReady,
      user,
      token: token || '',
    }),
    [isWebView, isAppReady, user, token]
  );

  useEffect(() => {
    // only allow smartlook records for prod
    if (import.meta.env.PROD) {
      //   window?.smartlook('init', 'ae7f1dffebddf76a8c07c241ecf97874b830f0b8', {
      //     region: 'eu',
      //   });
      window?.smartlook?.('init', import.meta.env.VITE_SMARTLOOK_KEY, {
        region: 'eu',
      });
      window?.smartlook('identify', user?.memberId as string, {
        memberId: user?.memberId,
        organisationId: user?.organisationId,
        email: user?.emailId,
      });
    }
  }, [user?.emailId, user?.organisationId, user?.memberId]);

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

const useAppContext = () => {
  const values = useContext(AppContext);
  if (!values) {
    throw new Error('App must be wrapped in AppProvider');
  }
  return values;
};

export { AppContext, useAppContext };
export default AppProvider;
